module.exports = __webpack_public_path__ + "img/12.3cb724e4.png";